export function DtoReqRegistrarBranding() {
    return{
        idUsuario: "",
        idSector: null,
        nombreEmpresa: "",
        descripcionEmpresa: "",
        mailEmpresarial: "",
        telefonoEmpresarial: "",
        paginaWeb: "",
        identidadDigital: "{\"marcaCheck\":false,\"logoCheck\":false,\"paginaWebCheck\":false,\"portafolioCheck\":false,\"redesSocialesCheck\":false}",
        nombreSector: "",
        idEmpresa: "",
        idLogo: "",
        logoEmpresa: "",
        fechaHoraCreacion: "",
        vigente: false,
        nombreArchivo: "",
        rutaImagen: ""
    }
}